module.exports = __webpack_public_path__ + "img/tab-history-selected.a5f93e27.png";